<template>
  <div class="image-uploader">
    <input
      ref="imageUploader"
      class="image-uploader__input-hidden"
      type="file"
      accept="image/*"
      hidden
      @change="changeFile"
    >

    <div class="image-uploader__box" @click="chooseFileTrigger">
      <img ref="imageBoxImg" src="" alt="">
    </div>

    <div class="image-uploader__new">
      <button class="btn btn-primary" @click="chooseFileTrigger">
        Choose new
        <span v-if="imageIsLoading" class="btn-loader" />
      </button>
    </div>

    <div v-if="imageChanged && uploadedImgUrl" class="image-uploader__old">
      <button class="btn btn-primary" @click="returnOldImage">Return old</button>
    </div>

    <div v-if="imageExist && removable" class="image-uploader__remove">
      <button class="btn btn-danger" @click="removeImage">Remove image</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',

  props: {
    uploadedImgUrl: {
      type: String,
      default: null,
    },
    remoteUrl: {
      type: Boolean,
      default: false,
    },
    removable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      imageExist: false,
      imageIsLoading: false,
      imageChanged: false,
    };
  },

  watch: {
    uploadedImgUrl() {
      if (this.uploadedImgUrl) {
        this.imageExist = true;
        $(this.$refs.imageBoxImg).attr('src', `${this.uploadedImgUrl}`);
      }
    },
  },

  mounted() {
    if (this.uploadedImgUrl) {
      this.imageExist = true;
      $(this.$refs.imageBoxImg).attr('src', `${this.uploadedImgUrl}`);
    }
  },

  methods: {
    chooseFileTrigger() {
      $(this.$refs.imageUploader).click();
    },
    returnOldImage() {
      document.querySelector('.image-uploader__input-hidden').value = '';
      $(this.$refs.imageBoxImg).attr('src', this.uploadedImgUrl);
      this.$emit('returnedOldFile');
      this.imageExist = true;
      this.imageChanged = false;
    },
    removeImage() {
      document.querySelector('.image-uploader__input-hidden').value = '';
      $(this.$refs.imageBoxImg).attr('src', '');
      this.imageExist = false;
      this.imageChanged = true;
      if (this.uploadedImgUrl) {
        this.$emit('existingFileRemoved');
      } else {
        this.$emit('changeFile', null);
      }
    },
    changeFile() {
      this.imageExist = true;
      this.imageChanged = true;
      if (this.$refs.imageUploader.files.length) {
        this.$emit('changeFile', this.$refs.imageUploader.files[0]);
        if (this.remoteUrl) {
          this.remoteUpload(this.$refs.imageUploader.files[0]);
        } else {
          this.readInputImage();
        }
      }
    },
    remoteUpload(file) {
      const fileData = new FormData();
      fileData.append('image', file);
      this.imageIsLoading = true;
      this.$http.post(this.remoteUrl, fileData, {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
        },
      }).then((response) => {
        this.$emit('remoteSuccess', response);
        this.readInputImage();
        this.imageExist = true;
        this.imageIsLoading = false;
      }).catch((error) => {
        console.error('error in remoteUpload request', error);
        this.imageIsLoading = false;
      });
    },
    readInputImage() {
      const $component = $(this.$el);
      const input = $component.find('input[type="file"]')[0];
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = function (e) {
          $component.find('.image-uploader__box img').attr('src', e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

<style>
.image-uploader__box {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #e4e5e6;
  cursor: pointer;
}
.image-uploader__box img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  transform: translate(-50%, -50%);
}
.image-uploader__new,
.image-uploader__old,
.image-uploader__remove {
  float: left;
  height: 150px;
  padding-top: 60px;
  padding-left: 20px;
}

.menu-builder__item-modal .image-uploader__new,
.menu-builder__item-modal .image-uploader__old,
.menu-builder__item-modal .image-uploader__remove {
  height: auto;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// ImageUploader.vue?5a19236e